import FileDownload from 'js-file-download'
import { accountingManagerDownload } from 'components/downloadAsCSV/produceDownloadForSAP'
import json2csv from 'json2csv'
const convertToCSV = json2csv.parse
export default async (
  crfList,
  { page, pageSize },
  isDownloadAll,
  crfToBeDownloaded = []
) => {
  const segregatedPageArray = []
  let listPerArrayCount = 0
  let arrayStorage = []
  let index = 0
  if (!isDownloadAll) {
    for (const obj of crfList) {
      if (listPerArrayCount <= pageSize) {
        arrayStorage.push(obj)
        listPerArrayCount = listPerArrayCount + 1
      }
      if (listPerArrayCount === pageSize) {
        listPerArrayCount = 0
        segregatedPageArray.push([...arrayStorage])
        arrayStorage = []
      }
      if (index === crfList.length - 1) {
        listPerArrayCount = 0
        segregatedPageArray.push([...arrayStorage])
        arrayStorage = []
      }
      index++
    }
  }
  // const csvData = []
  // const newCrfList = crfToBeDownloaded.map(id => {
  //   return crfList.find(data => data._id === id)
  // })
  let status = ''
  for (const obj of crfList) {
    if (status === '' || status === obj.status) {
      status = obj.status
    } else {
      status = 'All_Request'
    }
  }
  const crfListToBeDownload = !isDownloadAll
    ? segregatedPageArray[page]
    : crfList
  const csvData = await accountingManagerDownload(crfListToBeDownload)
  FileDownload(convertToCSV(csvData), `${status}(${currentDate()}).csv`)
}

const currentDate = () => {
  const dateArray = Date().split(' ')
  let month = ''
  const day = dateArray[2]
  const year = dateArray[3]
  switch (dateArray[1]) {
    case 'Feb':
      month = '02'
      break
    case 'Mar':
      month = '03'
      break
    case 'Apr':
      month = '04'
      break
    case 'May':
      month = '05'
      break
    case 'Jun':
      month = '06'
      break
    case 'Jul':
      month = '07'
      break
    case 'Aug':
      month = '08'
      break
    case 'Sep':
      month = '09'
      break
    case 'Oct':
      month = '10'
      break
    case 'Nov':
      month = '11'
      break
    case 'Dec':
      month = '12'
      break
    default:
      month = '01'
  }
  return `${year}-${month}-${day}`
}
